import { dataConfig } from 'data/dataConfig';

export function resolveFetchStatus(dataSet, filteredStatus) {
	if (dataSet === 'fdnyPermits2') {
		return filteredStatus || 'all';
	}
	if (dataSet === 'jobApplications') {
		return 'all';
	}
	if (dataSet === 'dobJobApplications') {
		return filteredStatus || 'all';
	}
	if (dataConfig[dataSet]?.hasStatus === false) {
		return filteredStatus;
	}
	return filteredStatus || 'open';
}

export function fetchActiveDataSetTable(
	dispatch,
	actions,
	{ propertyId, dataSet, reducerName, filteredStatus, searchString = '' },
) {
	if (!propertyId || !reducerName) {
		return;
	}
	const status = resolveFetchStatus(dataSet, filteredStatus);
	return dispatch(
		actions[reducerName].fetchData(propertyId, status, 1, searchString),
	);
}
